<template>
  <v-row class="fill-height">
    <v-col cols="2" class="text-h4 white-space-nowrap">
      {{ coreCard.value }}
    </v-col>
    <v-col cols="10">
      <div>
        <canvas ref="pieChart" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Chart from "chart.js";
export default {
  name: "CoreCardRecognition",
  props: {
    coreCard: { type: Object }
  },
  watch: {
    coreCard(val, oldVal) {
      if (val != oldVal) {
        this.updateChart();
      }
    }
  },
  data: () => ({
    colors: [
      "#efaa8d",
      "#23356e",
      "#db6015",
      "#444444",
      "#eaeaea",
      "#65729a",
      "#e6905b",
      "#7c7c7c",
      "#f0f0f0",
      "#919ab7",
      "#edb08a",
      "#A2a2a2",
      "#bdc2d4",
      "#f4cfb9",
      "#C7c7c7",
      "#000000"
    ]
  }),
  computed: {},
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      if (this.showBadges) {
        return;
      }
      this.chart = new Chart(this.$refs.pieChart, {
        type: "pie",
        data: {
          datasets: [
            {
              data: this.coreCard.coreValues.map(x => x.value),
              backgroundColor: this.colors,
              borderWidth: 0
            }
          ],
          labels: this.coreCard.coreValues.map(x => x.name)
        },
        options: {
          //responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  }
};
</script>
